import Clock from "@assets/svg/clock.svg";
import Profile from "@assets/svg/newCourses/profile.svg";
import Button from "@components/Button";
import Link from "next/link";
import React, { FC } from "react";

import { commafy, convertToJalali, getClassFormat } from "../../../src/utils";

interface Props {
  item: any;
  index: number;
}

const JobsSliderCard: FC<Props> = ({ item, index }) => {
  const getColor = (index: number) => {
    const colors = ["#4F9B0B", "#77268B", "#EE8A1E", "#0577AF"];
    return colors[index % colors.length];
  };
  return (
    <section className="p-2">
      <Link
        href={`/${item.entityType === 0 ? "course" : "package-details"}/${
          item.id
        }/${item.seoUrlDescription}`}
      >
        <a className={`block overflow-hidden rounded shadow`}>
          <img
            loading="lazy"
            src={item?.image}
            className="h-full w-full"
            alt="laptop 1111"
          />

          {item.certificateImage && item.certificateImage.length ? (
            <div className="relative -mt-9 mr-6 block h-[70px] w-[70px] overflow-hidden rounded bg-white p-2 shadow">
              <img
                loading="lazy"
                src={item?.image}
                className="h-full w-full"
                alt="laptop 222"
              />
            </div>
          ) : undefined}
          <div className="px-6 pt-4 pb-5">
            <h3
              className={`ellipsis-line ellipsis-line-clamp-2 h-[40px] text-sm font-bold text-blue-550 md:h-[48px] md:text-base lg:h-[54px] lg:text-lg ${
                !item?.certificateImage?.length && "mt-9"
              }`}
            >
              {item.title}
            </h3>
            <div className="mt-7 space-y-3 text-xs text-blue-550">
              <div className="flex">
                <Clock className="ml-2 fill-blue-550" />
                <p>
                  {item?.startDate
                    ? convertToJalali(item?.startDate)
                    : convertToJalali(item?.releaseDatetime)}{" "}
                  _ {item?.hour && `ساعت ${item?.hour} _`}{" "}
                  {getClassFormat(
                    item.entityType === 0 ? item?.courseType : item?.packageType
                  )}
                </p>
              </div>
              <div className="flex h-8">
                {item?.teacherNames && (
                  <>
                    <Profile className="ml-2 fill-blue-550 shrink-0" />
                    <p className="ellipsis-line ellipsis-line-clamp-2 scrollbar-none overflow-hidden overflow-ellipsis whitespace-normal">
                      {item?.teacherNames}{" "}
                    </p>
                  </>
                )}
              </div>
            </div>
            <div className={`mt-4 flex w-full items-center justify-between`}>
              <div
                className="flex md:flex-col 4xl:flex-row"
                style={{ color: getColor(index) }}
              >
                {item?.isBuyable && (
                  <>
                    {item?.price === 0 ? (
                      "رایگان"
                    ) : (
                      <>
                        <span className="ml-1 whitespace-nowrap text-base font-bold 2xl:ml-3">
                          {item?.discount !== null && item?.discount !== 0
                            ? commafy(item?.discount)
                            : commafy(item?.price)}{" "}
                          تومان
                        </span>
                        {item?.discount !== null && item?.discount !== 0 && (
                          <span className="ml-6 flex items-center whitespace-nowrap text-sm line-through">
                            {item?.price && commafy(item?.price)} تومان
                          </span>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              {item?.price === 0 && item?.isBuyable ? (
                <Button
                  spinnerColor="white"
                  style={{ background: getColor(index) }}
                  className="rounded-lg py-2 px-2 text-base text-white md:text-base xl:px-4 xl:text-base"
                >
                  افزودن به داشبورد
                </Button>
              ) : (
                <Button
                  spinnerColor="white"
                  style={{ background: getColor(index) }}
                  className={`rounded-lg bg-white py-2 px-3 text-white sm:px-5`}
                >
                  خرید
                </Button>
              )}
            </div>
          </div>
        </a>
      </Link>
    </section>
  );
};

export default JobsSliderCard;
